import { MergeTag } from '../types';

export const sortByFieldName = (a: MergeTag, b: MergeTag) => a.fieldName.localeCompare(b.fieldName);
